var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgExperts = function SvgExperts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m40.447 70.132 4.344-3.588 4.345 3.588V58.897h-8.689v11.235ZM40 14.252a13.553 13.553 0 1 0 13.553 13.553A13.568 13.568 0 0 0 40 14.252Zm0 24.38a10.829 10.829 0 0 1-7.656-18.483 10.827 10.827 0 0 1 18.483 7.656A10.836 10.836 0 0 1 40 38.615v.017Z",
    fill: "#296379"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.006 0a39.999 39.999 0 1 0 39.993 40A40.044 40.044 0 0 0 40.006 0ZM23.71 73.506v-6.384a16.297 16.297 0 0 1 16.293-15.997 16.295 16.295 0 0 1 16.292 15.997v6.384a37.217 37.217 0 0 1-32.586 0h.001Zm35.312-1.478v-4.906a19.02 19.02 0 0 0-19.02-18.699 19.023 19.023 0 0 0-19.018 18.7v4.906A37.275 37.275 0 0 1 40.003 2.7a37.274 37.274 0 0 1 19.019 69.33Z",
    fill: "#296379"
  })));
};

export default SvgExperts;